import React, { RefObject, useEffect, useState } from "react";
// @ts-ignore
import ChatMessage from "./chat-message.tsx";
// @ts-ignore
import ChatLoader from "./chat-loader.tsx";
import "./chat-body.scss";
// @ts-ignore
import ConnectingAnimation from "../ConnectingAnimation/ConnectingAnimation.tsx";
// @ts-ignore
import { IConfig } from "../web-socket-manager/web-socket-manager.ts";

interface Message {
	id: number;
	content: string;
	role: "user" | "assistant";
	buttons?: string[];
	timestamp: Date;
}

interface ChatBodyProps {
	messages: Message[];
	loading: boolean;
	is_reconnecting: boolean;
	messages_end_ref: RefObject<HTMLDivElement | null>;
	handle_button_click: (button_text: string) => void;
	config: IConfig;
}

const ChatBody: React.FC<ChatBodyProps> = ({
	messages,
	loading,
	is_reconnecting,
	messages_end_ref,
	handle_button_click,
	config,
}) => {
	const [allow_chat, set_allow_chat] = useState(false);

	useEffect(() => {
		setTimeout(() => {
			set_allow_chat(true);
		}, 6000);
	}, []);

	return (
		<div className="messages-container">
			{allow_chat ? (
				<>
					{messages.map((message) => (
						<ChatMessage
							config={config}
							key={message.id}
							message={message}
							handle_button_click={handle_button_click}
						/>
					))}

					{/* Loading indicator */}
					{loading && <ChatLoader />}

					{/* Reconnecting indicator */}
					{is_reconnecting && <ChatLoader is_reconnecting={true} />}

					<div ref={messages_end_ref} />
				</>
			) : (
				<ConnectingAnimation />
			)}
		</div>
	);
};

export default ChatBody;
